import { combineReducers, AnyAction } from '@reduxjs/toolkit'
import { reducer as oidc } from 'redux-oidc'

import { userReducer as user } from 'commons'
import { selection } from 'store/selection'
import { api } from 'store/api'

const reducer = combineReducers({
  oidc,
  user,
  api,
  selection,
})

export type RootState = ReturnType<typeof reducer>

export const rootReducer = (state: any, action: AnyAction) => {
  if (action.type === 'econtract/LOAD_PRESISTED_STATE') {
    const { oidc, user, api } = state
    state = {
      ...action.persistedState,
      oidc,
      user,
      api,
    }
  }

  return reducer(state, action)
}
